import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentforpunecitytour() {



const cardData =
{
  keyword: 'Bus on Rent for Pune City Tour',
  heading: 'Sanavi Travels: Bus on Rent for Pune City Tour',
  headingDescription: 'Sanavi Travels offers reliable, comfortable, and professionally managed Bus on Rent for Pune City Tour services, designed for families, tourists, school groups, corporate teams, wedding guests, and large sightseeing groups who want to explore Pune city in a relaxed and organized manner. Pune, known as the cultural capital of Maharashtra, is home to historic forts, spiritual landmarks, educational institutions, IT hubs, gardens, museums, and vibrant marketplaces.',

  top: 'Top Places Covered in Pune City Tour by Bus',

  "topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Shaniwar Wada is one of Pune’s most iconic historical landmarks and a must-visit destination during a Pune city tour. Hiring a bus allows groups to reach the site comfortably, manage parking easily, and explore the fort premises together while learning about Maratha history."
    },
    {
      "title": "Dagdusheth Halwai Ganpati Temple",
      "description": "The famous Dagdusheth Halwai Ganpati Temple attracts thousands of devotees daily. Bus rental ensures smooth group darshan visits without the hassle of coordinating multiple vehicles in crowded city areas."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Aga Khan Palace is a significant historical and memorial site associated with Mahatma Gandhi. Group bus travel allows visitors to reach the palace conveniently and explore the museum calmly."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Sinhagad Fort offers scenic views and historical importance. A hired bus is ideal for group travel to the fort base, ensuring safe uphill coordination and timely return."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum showcases rich Indian heritage and artifacts. Bus rental allows educational groups and tourists to visit comfortably and maintain schedules."
    },
    {
      "title": "Parvati Hill",
      "description": "Parvati Hill provides panoramic views of Pune city and spiritual significance. Group bus travel helps manage timing and ensures safe transportation for all age groups."
    },
    {
      "title": "Saras Baug",
      "description": "Saras Baug is a popular family-friendly garden destination. Bus tours allow families and picnic groups to travel together and enjoy leisure time."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "This ancient rock-cut temple is located in the heart of the city. Bus rental ensures convenient access despite busy traffic zones."
    },
    {
      "title": "Osho Ashram Area",
      "description": "The Koregaon Park and Osho Ashram area attracts international tourists. Bus tours help manage group visits smoothly in premium city locations."
    },
    {
      "title": "Educational & IT Hubs",
      "description": "Pune’s universities, colleges, and IT parks are often included in educational and corporate tours. Bus travel ensures organized and punctual movement."
    }
  ],

  "services": [
    {
      "name": "Bus on Rent for Pune City Tour",
      "description": "Sanavi Travels provides complete bus rental solutions for Pune city tours, covering historical landmarks, spiritual sites, educational institutions, gardens, and modern city attractions. Our service focuses on comfort, punctuality, and smooth coordination for group sightseeing."
    },
    {
      "name": "AC Bus for Pune City Tour",
      "description": "AC buses provide cool and comfortable travel, especially suitable during summer months and long sightseeing days across Pune city."
    },
    {
      "name": "Non AC Bus Rental Pune City Tour",
      "description": "Non AC buses are an economical choice for school tours, local group travel, and budget-friendly sightseeing."
    },
    {
      "name": "Luxury Bus Hire Pune City Tour",
      "description": "Luxury buses offer premium interiors, pushback seating, and enhanced comfort for corporate and high-end sightseeing groups."
    },
    {
      "name": "Mini Bus on Rent Pune City Tour",
      "description": "Mini buses are ideal for small families, tourists, and compact groups planning flexible Pune city tours."
    },
    {
      "name": "32 Seater Bus Pune City Tour",
      "description": "32 seater buses are suitable for medium-sized groups, offering balanced capacity and comfort."
    },
    {
      "name": "35 Seater Bus Hire Pune City Tour",
      "description": "35 seater buses accommodate large sightseeing groups, school trips, and corporate outings."
    },
    {
      "name": "Bus for Family Pune City Tour",
      "description": "Family-friendly bus services ensure safe, relaxed, and enjoyable city exploration for all age groups."
    },
    {
      "name": "Bus for Corporate Pune City Tour",
      "description": "Corporate city tours benefit from professional bus services with disciplined scheduling and comfort."
    },
    {
      "name": "Affordable Bus Rental Pune City Tour",
      "description": "Affordable packages help groups manage travel budgets without compromising service quality."
    },
    {
      "name": "Best Bus Service Pune City Tour",
      "description": "Sanavi Travels is trusted as one of the best providers for Pune city tour bus rentals."
    },
    {
      "name": "Bus with Driver Pune City Tour",
      "description": "All buses come with experienced drivers familiar with Pune routes, traffic, and tourist locations."
    },
    {
      "name": "Bus for Wedding Pune City Tour",
      "description": "Wedding guest transportation within Pune city is handled smoothly with comfortable buses."
    },
    {
      "name": "Bus for Picnic Pune City Tour",
      "description": "Picnic groups enjoy relaxed travel with ample seating and planned sightseeing stops."
    },
    {
      "name": "Bus for Sightseeing Pune City Tour",
      "description": "Sightseeing-focused bus services allow visitors to enjoy Pune attractions without travel stress."
    }
  ],

  "tableData": [
    ["Pune City Tour Bus", "Sightseeing Travel"],
    ["AC Bus", "Non AC Bus"],
    ["32 Seater Bus", "35 Seater Bus"],
    ["Luxury Bus", "Mini Bus"],
    ["Family Tour", "Corporate Tour"]
  ],

  "whychoose": [
    { "WhyChooseheading": "Experienced City Drivers", "WhyChoosedescription": "Drivers familiar with Pune city routes and traffic." },
    { "WhyChooseheading": "Comfortable Sightseeing Travel", "WhyChoosedescription": "Spacious seating and smooth rides." },
    { "WhyChooseheading": "Flexible Tour Plans", "WhyChoosedescription": "Customized itineraries supported." },
    { "WhyChooseheading": "Safe & Reliable Service", "WhyChoosedescription": "Well-maintained vehicles and disciplined driving." },
    { "WhyChooseheading": "Multiple Bus Options", "WhyChoosedescription": "Mini, standard, and luxury buses available." },
    { "WhyChooseheading": "Transparent Pricing", "WhyChoosedescription": "Clear and honest pricing." },
    { "WhyChooseheading": "Group-Friendly Travel", "WhyChoosedescription": "Entire group travels together." },
    { "WhyChooseheading": "Trusted Local Operator", "WhyChoosedescription": "Sanavi Travels is trusted in Pune." }
  ]
};

const faqData = [
  { question: 'Do you provide buses for Pune city tours?', answer: 'Yes, Sanavi Travels offers dedicated bus rental services for Pune city tours.' },
  { question: 'Are AC buses available for city tours?', answer: 'Yes, both AC and Non AC buses are available.' },
  { question: 'Can we customize the sightseeing itinerary?', answer: 'Yes, itineraries can be customized as per group preferences.' },
  { question: 'Is the service suitable for school trips?', answer: 'Yes, buses are safe and ideal for school and educational tours.' },
  { question: 'Do buses include drivers?', answer: 'Yes, all rentals include experienced city drivers.' },
  { question: 'Can buses be booked for corporate outings?', answer: 'Yes, corporate city tours are fully supported.' },
  { question: 'Is this service available for weddings?', answer: 'Yes, buses can be used for wedding guest movement.' },
  { question: 'Are vehicles well maintained?', answer: 'Yes, all buses are regularly serviced and cleaned.' },
  { question: 'Do you offer budget-friendly packages?', answer: 'Yes, affordable packages are available.' },
  { question: 'Is parking managed during sightseeing?', answer: 'Yes, drivers manage parking and route planning.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Kulkarni',
    feedback: 'Excellent Pune city tour bus service. Comfortable travel and very professional driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Neha Deshmukh',
    feedback: 'Best option for group sightseeing in Pune. Smooth and well-organized trip.',
    rating: 5
  }
];


























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus on Rent for Pune City Tour - Sanavi Travels",
  "description": "Sanavi Travels provides buses on rent for Pune city tours, including AC and Non-AC buses, luxury buses, 32-seater, 35-seater, and mini buses. Ideal for family trips, corporate tours, weddings, picnics, and sightseeing in Pune with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};




  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus on Rent for Pune City Tour | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book buses for Pune city tours with Sanavi Travels. AC & Non-AC buses, luxury buses, 32-seater, 35-seater, and mini buses for family trips, corporate tours, weddings, picnics, and sightseeing with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/292.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentforpunecitytour;